export const CHECKLIST_ITEM_TYPE = {
  ACCOUNT: "ACCOUNT",
  CATEGORIZATION: "CATEGORIZATION",
  REVIEW_PENDING_BANK_TRANSFERS: "REVIEW_PENDING_BANK_TRANSFERS",
  REVIEW_PENDING_CARD_PAYMENTS: "REVIEW_PENDING_CARD_PAYMENTS",
  REVIEW_VENDORS: "REVIEW_VENDORS",
  REVIEW_FIXED_ASSETS: "REVIEW_FIXED_ASSETS",
  REVIEW_JOURNAL_ENTRIES: "REVIEW_JOURNAL_ENTRIES",
  REVIEW_BALANCE_SHEET: "REVIEW_BALANCE_SHEET",
  REVIEW_CASHFLOW_STATEMENT: "REVIEW_CASHFLOW_STATEMENT",
  REVIEW_INCOME_STATEMENT: "REVIEW_INCOME_STATEMENT",
} as const;

export const FINALIZE_FINANCIALS_LABEL: Record<
  (typeof CHECKLIST_ITEM_TYPE)[keyof typeof CHECKLIST_ITEM_TYPE],
  string
> = {
  [CHECKLIST_ITEM_TYPE.ACCOUNT]: "Account",
  [CHECKLIST_ITEM_TYPE.CATEGORIZATION]: "Categorization",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_BANK_TRANSFERS]:
    "Review Pending Bank Transfers",
  [CHECKLIST_ITEM_TYPE.REVIEW_PENDING_CARD_PAYMENTS]:
    "Review Pending Card Payments",
  [CHECKLIST_ITEM_TYPE.REVIEW_VENDORS]: "Review Vendors",
  [CHECKLIST_ITEM_TYPE.REVIEW_FIXED_ASSETS]: "Review Fixed Assets",
  [CHECKLIST_ITEM_TYPE.REVIEW_JOURNAL_ENTRIES]: "Review Journal Entries",
  [CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET]: "Balance Sheet",
  [CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT]: "Cash Flow Statement",
  [CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT]: "Income Statement",
};

export const CHECKLIST_ITEM_SECTION = {
  RECONCILE_ACCOUNTS: "RECONCILE_ACCOUNTS",
  VERIFY_CATEGORIZATION: "VERIFY_CATEGORIZATION",
  REVIEW_CHANGES: "REVIEW_CHANGES",
  FINALIZE_FINANCIALS: "FINALIZE_FINANCIALS",
  OTHER_ACTION: "OTHER_ACTION",
} as const;

export const CLOSING_SUMMARY_KEY = {
  REVENUE: "revenue",
  COGS: "cogs",
  OPERATING_EXPENSES: "operating_expenses",
  NET_PROFIT: "net_profit",
  CASH_BALANCE: "cash_balance",
  CASH_BURN: "cash_burn",
} as const;

export const CLOSING_STATUS = {
  IN_PROGRESS: "IN_PROGRESS",
  REVIEW_PENDING: "REVIEW_PENDING",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  REQUEST_CHANGES: "REQUEST_CHANGES",
  AMENDED: "AMENDED",
  PENDING_INFO: "PENDING_INFO",
} as const;

export const CHANGE_REQUEST_STATUS = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
} as const;

export const CLOSING_DOCUMENT_REVIEW_STATUS = {
  NOT_REVIEWED: "NOT_REVIEWED",
  REVIEWED: "REVIEWED",
} as const;

export type CLOSING_DOCUMENT_REVIEW_STATUS_TYPE =
  (typeof CLOSING_DOCUMENT_REVIEW_STATUS)[keyof typeof CLOSING_DOCUMENT_REVIEW_STATUS];

export const VARIANCE_REPORT_STATUS = {
  NOT_GENERATED: "NOT_GENERATED",
  GENERATED: "GENERATED",
} as const;

export type VarianceReportStatusType =
  (typeof VARIANCE_REPORT_STATUS)[keyof typeof VARIANCE_REPORT_STATUS];

export const VARIANCE_REPORT_MODE = {
  GENERATE: "GENERATE",
  VIEW: "VIEW",
  REGENERATE: "REGENERATE",
} as const;

export type VarianceReportModeType =
  (typeof VARIANCE_REPORT_MODE)[keyof typeof VARIANCE_REPORT_MODE];

export const DOCUMENT_STATUS = {
  UPLOAD: "UPLOAD",
  GENERATE: "GENERATE",
  NONE: "NONE",
} as const;

export type DOCUMENT_STATUS_TYPE =
  (typeof DOCUMENT_STATUS)[keyof typeof DOCUMENT_STATUS];

export const finalizeFinancialsOrder = [
  CHECKLIST_ITEM_TYPE.REVIEW_BALANCE_SHEET,
  CHECKLIST_ITEM_TYPE.REVIEW_INCOME_STATEMENT,
  CHECKLIST_ITEM_TYPE.REVIEW_CASHFLOW_STATEMENT,
];

export const FINANCIAL_CLOSING_V1_DATE = "2025-11-22";

export const RND_SECTION_TYPE = {
  INTERCOMPANY_COMPENSATION: "INTERCOMPANY_COMPENSATION",
  CONSULTANT_CONTRACTOR: "CONSULTANT_CONTRACTOR",
} as const;

export const RND_ONBOARDING_STEP = {
  INTRO: "INTRO",
  WHY_THIS_MATTERS: "WHY_THIS_MATTERS",
  HOW_IT_WORKS: "HOW_IT_WORKS",
  HOW_TO_DO_IT: "HOW_TO_DO_IT",
  COMPLETED: "COMPLETED",
} as const;

export const RND_ONBOARDING_STEP_INDEX = {
  [RND_ONBOARDING_STEP.INTRO]: 0,
  [RND_ONBOARDING_STEP.WHY_THIS_MATTERS]: 1,
  [RND_ONBOARDING_STEP.HOW_IT_WORKS]: 2,
  [RND_ONBOARDING_STEP.HOW_TO_DO_IT]: 3,
  [RND_ONBOARDING_STEP.COMPLETED]: 4,
} as const;

export const RND_ONBOARDING_STEP_BY_INDEX: Record<
  0 | 1 | 2 | 3 | 4,
  (typeof RND_ONBOARDING_STEP)[keyof typeof RND_ONBOARDING_STEP]
> = {
  0: RND_ONBOARDING_STEP.INTRO,
  1: RND_ONBOARDING_STEP.WHY_THIS_MATTERS,
  2: RND_ONBOARDING_STEP.HOW_IT_WORKS,
  3: RND_ONBOARDING_STEP.HOW_TO_DO_IT,
  4: RND_ONBOARDING_STEP.COMPLETED,
};
